import { z } from 'zod/v4';
import { AttributeModifiersDTO, AttributeSchemaDTO } from './types';

export const AttributeInstanceDTO = z.object({
  attribute_name: z.string(),
  value: z.any(),
  value_schema: AttributeSchemaDTO,
  modifiers: AttributeModifiersDTO.optional(),
  is_secret: z.boolean().optional(),
  has_value: z.boolean().optional(),
});

export type AttributeInstance = z.infer<typeof AttributeInstanceDTO>;

export const AttributeValuesDTO = z.record(z.string(), AttributeInstanceDTO);

export type AttributeValues = z.infer<typeof AttributeValuesDTO>;